import {useFormatCurrency} from '@aboutyou/i18n';
import React, {FC, Fragment} from 'react';
import {Price} from '../../../../types/Price';
import {PriceBoxProps} from '../PriceBox';
import {Badge, SalesCell, SalesRow, StruckPrice} from './Shared';

export const Reductions: FC<
  Pick<
    PriceBoxProps,
    | 'price'
    | 'CountdownComponent'
    | 'align'
    | 'hideBadges'
    | 'reverseReductions'
  > & {price: Price}
> = ({
  price,
  CountdownComponent,
  align = 'left',
  hideBadges,
  reverseReductions,
}) => {
  const formatCurrency = useFormatCurrency();

  return (
    <SalesRow
      data-has-countdown={Boolean(
        price.reductions.some(
          reduction => CountdownComponent && reduction.badge?.endsAt,
        ),
      )}
      $align={align}
    >
      {!hideBadges && (
        <SalesCell>
          {price.reductions?.map((reduction, index) => {
            if (!reduction.badge) {
              return null;
            }

            return (
              <Fragment key={reduction.badge.text + index}>
                {CountdownComponent && reduction.badge.endsAt && (
                  <CountdownComponent
                    endDate={reduction.badge.endsAt}
                    backgroundColor={reduction.badge.backgroundColor.hex}
                  />
                )}
                <Badge
                  data-testid="badge-sale"
                  data-has-countdown={Boolean(
                    CountdownComponent && reduction.badge.endsAt,
                  )}
                  $foregroundColor={reduction.badge.foregroundColor.hex}
                  $backgroundColor={reduction.badge.backgroundColor.hex}
                  data-untranslated-label="sale"
                >
                  {reduction.badge?.text}
                </Badge>
              </Fragment>
            );
          })}
        </SalesCell>
      )}
      <SalesCell $reverse={reverseReductions}>
        {price.reductions?.map((reduction, index) => (
          <StruckPrice
            key={reduction.strikePrice.amount + index}
            striked
            data-testid={`strikePrice`}
          >
            {formatCurrency(
              reduction.strikePrice.amount,
              reduction.strikePrice.currencyCode,
            )}
          </StruckPrice>
        ))}
      </SalesCell>
    </SalesRow>
  );
};
